import React, { useContext } from "react";
import { LangContext } from '../../../../context/DataContext';
import Conclusiones from "./Conclusiones";
import FuentesDeDatos from "./FuentesDeDatos";
import Fundamentacion from "./Fundamentacion";
import Metodologia from "./Metodologia";
import Objetivos from "./Objetivos";
import Resultados from "./Resultados";
import Resumen from "./Resumen";


const DNSOverTLS = () => {

  return (
    <>

      <ReportTitle />
      <Resumen />
      <Objetivos />
      <Fundamentacion />
      <FuentesDeDatos />
      <Metodologia />
      <Resultados />
      <Conclusiones /></>

  );
};

const ReportTitle = () => {
  const { myLang } = useContext(LangContext);

  return (
    <div >

      <div  >
        {myLang === 'es' && <h1>Uso de DNS-over-TLS en Latinoamérica y el Caribe</h1>}
        {myLang === 'en' && <h1>Use of DNS-over-TLS In Latin America and the Caribbean</h1>}
        {myLang === 'pt' && <h1>Uso do DNS-over-TLS na América Latina e o Caribe</h1>}
      </div>
    </div>
  );
};



export default DNSOverTLS